import { Box, ColorOptions, ModBox, Spacer, Text } from '@jfs/ui-new'
import { View } from 'react-native'
import { SvgImage } from '../../../../comps/SvgImage'
import { Colors } from '../../../../util/util'

export const Delete = ({ onPressItem, status, onDissMiss }) => {
  const blockActionType = status === 'ACTIVE' ? 'BLOCK' : 'UNBLOCK'
  return (
    <Box borderTopLeftRadius={30} borderTopRightRadius={30} bg="WHITE" overflow={'hidden'} p={25} pt={30}>
      <Box onPress={onDissMiss} testID="close" underlayColor={'TRANSPARENT'} align="flex-end">
        <SvgImage imageName="Close" />
      </Box>
      <ModBox
        flexDirection={'row'}
        align="center"
        show={status === 'ACTIVE' || status === 'BLOCKED'}
        underlayColor={'TRANSPARENT'}
        marginVertical={15}
        testID="user-status"
        onPress={() => onPressItem(blockActionType)}>
        <View style={{ transform: [{ scale: 1.4 }] }}>
          <SvgImage
            imageName={status === 'ACTIVE' ? 'ItemUnChecked' : 'ItemChecked'}
            color={status === 'ACTIVE' ? Colors.SECONDARY : '#00B259'}
          />
        </View>
        <Spacer size={20} direction="horizontal" />
        <Text fontFamily="JioType-Medium" fontSize={14} color={'BLACK'}>
          {status === 'ACTIVE' ? 'Block User' : status === 'BLOCKED' ? 'Un Block' : ''}
        </Text>
      </ModBox>
      <Box
        flexDirection={'row'}
        disabled={status === 'TERMINATED'}
        alignSelf={'flex-start'}
        underlayColor={'TRANSPARENT'}
        align="center"
        marginVertical={15}
        testID="delete-user"
        onPress={() => onPressItem('DELETE')}>
        <Box {...{ transform: [{ scale: 1.0 }] }}>
          <SvgImage imageName="DeleteIcon" />
        </Box>
        <Spacer size={15} direction="horizontal" />
        <Text color={'TEXT_ERROR' as ColorOptions} fontFamily="JioType-Medium" fontSize={14}>
          {status === 'TERMINATED' ? 'Deleted' : 'Delete User'}
        </Text>
      </Box>
    </Box>
  )
}
